define("shared/components/shared/pre-boarding/survey-components/single-choice-selector", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Ui::Button
    @onClick={{fn @selectRadioButtonResponse @question.identifier @option.value @index}}
    @variant="unstyled"
    class={{concat-classes
      "tUG--questionCard__input"
      "tUG--questionCard__input--singleChoice"
      "o--btn--a11y"
      @option.qaClass
      (if this.isSelected "is--active" "is--disable")
    }}
    data-test-survey="single-choice-selector"
    {{(modifier
      "touch-gesture"
      onTouchEnd=(fn @onTouchEnd @question.identifier @option.value)
      onTouchStart=@onTouchStart
      onTouchMove=@onTouchMove
    )}}
  >
    {{@option.text}}
  </Shared::Ui::Button>
  */
  {
    "id": "fMWDOn/5",
    "block": "[[[8,[39,0],[[16,0,[28,[37,1],[\"tUG--questionCard__input\",\"tUG--questionCard__input--singleChoice\",\"o--btn--a11y\",[30,1,[\"qaClass\"]],[52,[30,0,[\"isSelected\"]],\"is--active\",\"is--disable\"]],null]],[24,\"data-test-survey\",\"single-choice-selector\"],[4,[50,[28,[37,5],[\"modifier:touch-gesture\"],null],2,null,[[\"onTouchEnd\",\"onTouchStart\",\"onTouchMove\"],[[28,[37,3],[[30,5],[30,3,[\"identifier\"]],[30,1,[\"value\"]]],null],[30,6],[30,7]]]],null,null]],[[\"@onClick\",\"@variant\"],[[28,[37,3],[[30,2],[30,3,[\"identifier\"]],[30,1,[\"value\"]],[30,4]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n  \"],[1,[30,1,[\"text\"]]],[1,\"\\n\"]],[]]]]]],[\"@option\",\"@selectRadioButtonResponse\",\"@question\",\"@index\",\"@onTouchEnd\",\"@onTouchStart\",\"@onTouchMove\"],false,[\"shared/ui/button\",\"concat-classes\",\"if\",\"fn\",\"modifier\",\"-resolve\"]]",
    "moduleName": "shared/components/shared/pre-boarding/survey-components/single-choice-selector.hbs",
    "isStrictMode": false
  });

  class SingleChoiceSelectorComponent extends _component2.default {
    get isSelected() {
      return this.args.surveyResponses[this.args.question.identifier] === this.args.option.value;
    }

  }

  _exports.default = SingleChoiceSelectorComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SingleChoiceSelectorComponent);
});